import { safeStorage } from '@/services/storage'
import type { User } from '@/types'
import { AUTH_STORAGE_KEY, type AuthData } from './types'

export function storeAuthData(authData: AuthData): void {
  safeStorage.setItem(AUTH_STORAGE_KEY, authData)
}

export function getAuthData(): AuthData | null {
  return safeStorage.getItem<AuthData>(AUTH_STORAGE_KEY)
}

export function clearAuthData(): void {
  safeStorage.removeItem(AUTH_STORAGE_KEY)
}

export function updateStoredUser(partial: Partial<User>): void {
  const authData = getAuthData()
  if (!authData) return
  storeAuthData({
    ...authData,
    user: { ...authData.user, ...partial },
  })
}
